import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import AddNewServiceValidation from "../../../../yup/Service/AddService";
import CommanForm from "../../../../components/FormController/Commanform";
import { CategoryAction } from "../../../../redux/Action/ProfileAction";
import Sidebar from "../../../../components/Layout/Sidebar";
import Breadcrumb from "../../../../components/Breadcrumb/Breadcrumb";
import Addcategory from "../../../../components/Model/Addcategory";
import CategoryItem from "./CategoryItem";
import Errormessages from "../../../../components/ErrorMessage/Errormessages";
import Select from 'react-select';
import { durationOptions } from "../../../../constants/Constants";
import { handleInput } from "../../../../utils/Helper";
import StaffMemberItem from "./StaffMemberItem";
import { AddServiceAction } from "../../../../redux/Action/DashboardAction";
import Button from "../../../../components/Ui/Button";
import { useNavigate } from "react-router-dom";

import { FormattedMessage } from "react-intl";
import { useIntl } from 'react-intl';

const AddSevice = () => {
    const intl = useIntl();

    const local_language = localStorage.getItem('lang')

    const dispatch = useDispatch<any>();
    const addServiceData = useSelector((state: any) => state.AddServiceState)
    const categoryData = useSelector((state: any) => state.CategoryState);

    const navigate = useNavigate()
    const [Service, setService]: any = useState([{ id: "1" }]);

    const [serviceError, setServiceError] = useState("");
    const [categories, setcategories] = useState([])
    const [categoryError, setCategoryError] = useState("")
    const validationSchema = AddNewServiceValidation(Service.map((service: any) => service.id));
    const { register, errors, handleSubmit, setValue, trigger, watch, getValues } = CommanForm({ validationSchema: validationSchema });


    const handleAddDiv = () => {
        const newServiceId = String(Service.length + 1);
        setService([...Service, { id: newServiceId }]);
        setValue(`name_${newServiceId}`, '');
        setValue(`description_${newServiceId}`, '');
        setValue(`price_${newServiceId}`, '');
        setValue(`duration_${newServiceId}`, '');
        setValue(`selectedStaffMembers_${newServiceId}`, '');
        trigger()
        setServiceError("");
    };

    const handleRemoveDiv = (id: any) => {
        setService(Service.filter((div: any) => div.id !== id));
    };



    useEffect(() => {
        if (Service.length == 0) {
            return setServiceError("Please add at least one service")
        }
        setServiceError("")
    }, [Service]);



    const handleAddCategoryClick = () => {
        dispatch(CategoryAction({ exclude: true }));
    }

    useEffect(() => {
        if (addServiceData?.status) {
            navigate("/service-management")
        }
    }, [addServiceData]);


    /* *************************** handle on submit *************************** */
    const onSubmit = (payload: any) => {
        const idValues = Service.map((item: any) => item.id);

        // Filter payload based on ids present in idValues
        const filteredPayload = Object.keys(payload).reduce((acc: any, key: any) => {
            const idNumber = key.split('_')[1]; // Extract the number from the key (e.g., "name_1" -> "1")
            if (idValues.includes(idNumber)) {
                acc[key] = payload[key];
            }
            return acc;
        }, {});


        if (Service?.length == 0) {
            return setServiceError("Please add at least one service")
        }
        setServiceError("")

        if (categories?.length == 0 || categories == null) {
            return setCategoryError(local_language == "alb" ? "Ju lutemi zgjidhni të paktën një kategori." : "Please select at least one category.")
        }
        setCategoryError("")

        const arrayData = [];

        for (let i = 1; filteredPayload.hasOwnProperty(`name_${i}`); i++) {
            arrayData.push({
                name: payload[`name_${i}`],
                price: payload[`price_${i}`],
                duration: Number(payload[`duration_${i}`]),
                description: payload[`description_${i}`],
                staff_ids: payload[`selectedStaffMembers_${i}`],
                cat_id: categories
            });
        }
        const data = { services: arrayData }
        dispatch(AddServiceAction(data));
    };


    const handleSelectChange = (selectedOption: any, id: any) => {
        setValue(`duration_${id}`, selectedOption ? selectedOption.value : ''); // Set form value
        trigger(`duration_${id}`)
    };

    const handleSelectedCategory = (id: any) => {
        setcategories(id)
    }

    const handleSelectedStaffMember = (id: any, serviceId: any) => {
        
        setValue(`selectedStaffMembers_${serviceId?.id}`, id ? id : ''); 
        trigger(`selectedStaffMembers_${serviceId?.id}`)

        setService((prevServices: any) => {
            return prevServices.map((service: any) => {
                if (service.id === serviceId) {
                    return { ...service, selectedStaffMembers: id };
                }
                return service;
            });
        });
    };

    useEffect(() => {
        dispatch(CategoryAction({ exclude: true }));
    }, [])

    const handleError = () => {
        if (categories?.length == 0 || categories == null) {
            return setCategoryError(local_language == "alb" ? "Ju lutemi zgjidhni të paktën një kategori." : "Please select at least one category.")
            // return setCategoryError("Please select at least one category.")
        } else {
            setCategoryError("")
        }

    }

    useEffect(() => {
        setCategoryError("")
    }, [categories]);


    const breadcrumbItemsEdit = [
        { title: 'dashboard', link: '/dashboard' },
        { title: 'Add_New_Service' }
    ];

    useEffect(() => {
        return () => {
            dispatch(AddServiceAction("RESET"))
            dispatch(CategoryAction("RESET"))
        }
    }, []);


    const sidebarOpen = () => {
        $(".leftsidebar").addClass("active")
    }

    return (
        <>
            <div className='container-fluid my-5'>
                <div className='row align-items-stretch'>
                    <div className='col-lg-3 leftsidebar'>
                        <Sidebar />
                    </div>
                    <div className='col-lg-9 addNewService'>
                        <div className='dashboard bg-white'>
                            <div className='dashboardTop'>
                                <h2><button onClick={() => { sidebarOpen() }} type='button' className='btn mobileMenu p-1 d-lg-none'><span className="icon-menu-right"></span></button> <FormattedMessage id="add_new_service" /> </h2>
                                <Breadcrumb items={breadcrumbItemsEdit} />
                            </div>
                            <div className='dashboarcard'>

                                <form onSubmit={handleSubmit(onSubmit)} >
                                    <div className='profileINfo'>
                                        <ul className='addCategory'>
                                            {

                                                <li className='addCatBTN cursor-pointer' data-bs-toggle="modal" data-bs-target="#AddCategory"
                                                    onClick={handleAddCategoryClick}  >
                                                    <figure><i className="icon-plus-line"></i></figure>
                                                    <p><FormattedMessage id="add_category" /></p>
                                                </li>


                                            }
                                            <li>
                                                <CategoryItem handleSelectedCategory={handleSelectedCategory} watch={watch} />
                                                {/* <CategoryItem handleSelectedCategory={handleSelectedCategory} categoryError={categoryError} watch={watch} /> */}
                                            </li>
                                        </ul>
                                        <p className='text-danger mt-0'> {categoryError} </p>

                                        {/* {<p className="text-danger"> {serviceError}</p>} */}

                                        <div className='row'>
                                            <div className='col-xl-10'>
                                                <div className='d-sm-flex justify-content-between align-items-center mb-2'>
                                                    <h6 className='my-4'>{<FormattedMessage id="add_new_service" />}</h6>
                                                    <button type='button' className='btn btnOUtlinePrimary' onClick={handleAddDiv}>+{<FormattedMessage id="add_new_service" />}</button>
                                                </div>
                                                {Service.map((item: any, index: any) => {

                                                    return (
                                                        <div key={item?.id} className='serviceRow mb-4'>
                                                            <div className='row gx-2 gy-4'>
                                                                <div className='col'>
                                                                    <div className='row gy-4'>
                                                                        <div className="col-md-4 normalINput">
                                                                            <label className="form-label">{<FormattedMessage id="service_name" />}</label>
                                                                            <input type="text" className="form-control"
                                                                                placeholder={intl.formatMessage({ id: 'enter_service_name' })}
                                                                                {...register(`name_${item.id}`)}
                                                                                maxLength={25}
                                                                                onInput={(e: any) => {
                                                                                    const value = e.target.value.replace(/\s{2,}/g, ' ');
                                                                                    setValue(`name_${item.id}`, value);
                                                                                }}
                                                                            />
                                                                            <Errormessages errors={errors} name={`name_${item.id}`} />
                                                                        </div>

                                                                        <div className="col-md-4 normalINput normalINputIcon">
                                                                            <label className="form-label"><FormattedMessage id="service_price" /></label>
                                                                            <div className="position-relative">
                                                                                <input type="text" className="form-control" placeholder="00.00/person"
                                                                                    {...register(`price_${item.id}`)} onInput={handleInput} />
                                                                                <span className='priceSIgn'>€</span>
                                                                            </div>
                                                                            <Errormessages errors={errors} name={`price_${item.id}`} />
                                                                        </div>

                                                                        <div className="col-md-4 normalINput">
                                                                            <label className="form-label"><FormattedMessage id="service_duration" /></label>
                                                                            <Select
                                                                                {...register(`duration_${item.id}`, { required: true })}
                                                                                options={durationOptions}
                                                                                placeholder={intl.formatMessage({ id: 'service_duration' })}

                                                                                onChange={(e: any) => handleSelectChange(e, item?.id)}
                                                                            />
                                                                            <Errormessages errors={errors} name={`duration_${item.id}`} />
                                                                        </div>

                                                                        <div className="col-md-12 normalINput">
                                                                            <label className="form-label"><FormattedMessage id="service_description" /></label>
                                                                            <textarea className="form-control" rows={3}

                                                                                placeholder={intl.formatMessage({ id: 'write_description' })}

                                                                                {...register(`description_${item.id}`)}
                                                                                onInput={(e: any) => {
                                                                                    const value = e.target.value.replace(/\s{2,}/g, ' ');
                                                                                    setValue(`description_${item.id}`, value);
                                                                                }}
                                                                            ></textarea>
                                                                            <Errormessages errors={errors} name={`description_${item.id}`} />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                {Service?.length > 1 && index > 0 && (
                                                                    <div className='col-auto'>
                                                                        <button
                                                                            type='button'
                                                                            className='btn closeBTN p-0'
                                                                            onClick={() => handleRemoveDiv(item?.id)}
                                                                        >
                                                                            <span className="icon-close"></span>
                                                                        </button>
                                                                    </div>
                                                                )}
                                                                {/* {
                                                                    Service?.length > 1 &&
                                                                    <div className='col-auto'><button type='button' className='btn closeBTN p-0' onClick={() => handleRemoveDiv(item?.id)}><span className="icon-close"></span></button></div>

                                                                } */}
                                                            </div>
                                                            <div className='category staffRow mt-3'>
                                                                <h6><FormattedMessage id="staff_member" /> </h6>
                                                                <ul>
                                                                    <StaffMemberItem handleSelectedStaffMember={handleSelectedStaffMember} data={item} watch={watch} />
                                                                </ul>
                                                                <Errormessages errors={errors} name={`selectedStaffMembers_${item.id}`} />
                                                            </div>
                                                        </div>
                                                    )
                                                }
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                    <Button text={<FormattedMessage id="Save" /> as any} type="Submit" className="btn btn-fill" onClick={handleError} isLoading={addServiceData?.loading} />
                                    {/* <button type="submit" className="btn btn-fill" onClick={handleError}>Save</button> */}
                                </form>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Addcategory />
        </>
    )
}

export default AddSevice;

